import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import type { FC } from 'react';

interface ConfirmAddLabourItemDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  labourItemName?: string;
  plotName?: string;
  plotNumber?: string;
}

/**
 * Confirmation dialog for adding a labour item to a plot
 * Shows before submission to confirm the details
 */
export const ConfirmAddLabourItemDialog: FC<
  ConfirmAddLabourItemDialogProps
> = ({ open, onClose, onConfirm, labourItemName, plotName, plotNumber }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Add Labour Item</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Add <strong>{labourItemName || 'this labour item'}</strong> to{' '}
          <strong>
            {plotName} ({plotNumber})
          </strong>
          ?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
